// ===================================
// Purchase Print Service - Updated PDF Generation
// ===================================
import dayjs from 'dayjs';
import pdfMake from "pdfmake/build/pdfmake";
import vfsFonts from "pdfmake/build/vfs_fonts";   // ไฟล์ที่ generate ไว้เอง
import { userService } from './userService';
import { formatCurrency, numberToThaiText } from '../utils/helpers';
import { loadImageBase64 } from "../utils/loadImageBase64";
import { buildUploadUrl } from '../config/runtimeConfig';
import {
  createSignatureImageNode,
  getCompanySignatureLayout,
  normalizeSignatureLayout
} from '../utils/signatureLayout';


// ตั้งค่าให้ pdfMake ใช้ฟอนต์จาก vfs_fonts
pdfMake.vfs = vfsFonts;


pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew Italic.ttf',
    bolditalics: 'THSarabunNew BoldItalic.ttf'
  }
};


class PurchasePrintService {

  // Get company information
  async getCompanyInfo() {


    try {
      // You should fetch this from your API
      return {
        name: 'บริษัทของคุณ จำกัด',
        address: 'ที่อยู่บริษัทของคุณ',
        phone: 'หมายเลขโทรศัพท์บริษัท',
        email: 'info@company.com',
        taxId: 'เลขประจำตัวผู้เสียภาษี'
      };
    } catch (error) {
      console.error('Error fetching company info:', error);
      return {
        name: 'บริษัทของคุณ จำกัด',
        address: 'ที่อยู่บริษัทของคุณ',
        phone: 'หมายเลขโทรศัพท์บริษัท',
        email: 'info@company.com',
        taxId: 'เลขประจำตัวผู้เสียภาษี'
      };
    }
  }


  // =============================================================================
  // PURCHASE ORDER PDF
  // =============================================================================

  async generatePurchaseOrderPDF(company, orderData, signatureLayout = null) {
    try {
      //const companyInfo = company;
      const res = await userService.getUserById(orderData.created_by);
      const userInfo = res.data;

      //กรณีใช้ local logo:   process.env.PUBLIC_URL + "/assets/ttlogo.png"
      const logoBase64 = await loadImageBase64(buildUploadUrl(company?.logo_path));
      const signatureBase64 = await loadImageBase64(buildUploadUrl(company?.signature_path), {
        transparentWhite: true,
        whiteThreshold: 245
      });
      const resolvedSignatureLayout = signatureLayout
        ? normalizeSignatureLayout(signatureLayout, 'purchase_order')
        : getCompanySignatureLayout(company, 'purchase_order');
      const signatureImageNode = createSignatureImageNode(
        signatureBase64,
        resolvedSignatureLayout,
        'purchase_order',
        { margin: [0, 0, 0, -8] }
      );

      console.log('odrder data', { company: company, ...orderData });
      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [50, 30, 30, 30],
        defaultStyle: {
          font: 'THSarabunNew',
          fontSize: 14
        },

        content: [

          // Header
          {
            lineHeight: 0.8,
            columns: [
              logoBase64 ? {
                image: logoBase64,
                width: 50,
                alignment: 'left',
                margin: [0, 10, 0, 0]
              } : { text: '', width: 50 },

              // Company Info
              {
                stack: [
                  { text: company?.company_name, style: 'companyName' },
                  { text: company?.address, style: 'companyInfo' },
                  { text: `โทร: ${company?.phone}`, style: 'companyInfo' },
                  { text: `Email: ${company?.email}`, style: 'companyInfo' },
                  { text: `เลขประจำตัวผู้เสียภาษี: ${company?.tax_id} ${company.branch_name?`(${company?.branch_name})`:''}`, style: 'companyInfo' }
                ],
                width: '*'
              },

              // Document Title
              {
                stack: [
                  { text: 'ใบสั่งซื้อ', style: 'documentTitle' },
                  { text: 'PURCHASE ORDER', style: 'documentTitleEn' }
                ],
                width: 'auto',
                alignment: 'right'
              }
            ],
            columnGap: 20,
            margin: [0, 0, 0, 5]
          },
          {
            canvas: [
              {
                type: 'rect',
                x: 0,
                y: 0,
                w: 160, // กำหนดความกว้างของพื้นหลัง (ปรับได้)
                h: 65,  // กำหนดความสูงของพื้นหลัง (พอดีข้อความ)
                r: 10,  // ความมนของขอบ 10px
                color: '#E3F2FD' // 💙 สีฟ้าอ่อน
              }
            ],
            absolutePosition: { x: 395, y: 111 }, // ปรับตำแหน่งตาม layout ของคุณ
          },
          // Document Info
          {
            lineHeight: 0.8,
            columns: [
              {
                stack: [
                  { text: 'ผู้จำหน่าย', style: 'sectionHeader', margin: [0, 0, 0, 5] },
                  { text: orderData.supplier_name, style: 'supplierInfo' },
                  { text: orderData.company_name || '', style: 'supplierInfo' },
                  { text: orderData.address || '', style: 'supplierInfo' },
                  { text: `โทร: ${orderData.phone || ''}`, style: 'supplierInfo' },
                  { text: `Email: ${orderData.email || ''}`, style: 'supplierInfo' }
                ],
                width: '*'
              },
              {
                margin: [100, 0, 0, 5],
                stack: [

                  { text: `เลขที่ใบสั่งซื้อ: ${orderData.purchase_number}`, style: 'documentInfo' },
                  { text: `วันที่: ${this.formatDate(orderData.purchase_date)}`, style: 'documentInfo' },
                  { text: `วันที่รับของ: `, style: 'documentInfo' },
                  // { text: `ประเภทการชำระ: ${this.getPaymentTypeText(orderData.payment_type)}`, style: 'documentInfo' }
                ],
                width: '*'
              },
            ],
            columnGap: 20,
            margin: [0, 0, 0, 5]
          },
          {
            text: `ตามที่ ${orderData.supplier_name} ได้เสนอราคาไว้ต่อ ${company.company_name}`,
            fontSize: 14,
            margin: [30, 0, 0, 0]
          },
          {
            text: `ซึ่งได้รับราคาและตกลงซื้อ ตามรายการดังต่อไปนี้`,
            fontSize: 14,
            margin: [5, 0, 0, 10]
          },

          // Items Table
          {
            table: {
              headerRows: 1,
              widths: [50, 150, 50, 50, 65, '*'],
              body: [
                [
                  { text: 'ลำดับ', style: 'tableHeader' },
                  { text: 'รายการสินค้า', style: 'tableHeader' },
                  { text: 'จำนวน', style: 'tableHeader' },
                  { text: 'หน่วย', style: 'tableHeader' },
                  { text: 'ราคา/หน่วย', style: 'tableHeader' },
                  { text: 'จำนวนเงิน', style: 'tableHeader' }
                ],
                ...orderData.items.map((item, index) => [
                  { text: (index + 1).toString(), style: 'tableCell', alignment: 'center' },
                  { text: item.product_name, style: 'tableCell' },
                  { text: this.formatNumber(item.quantity), style: 'tableCell', alignment: 'right' },
                  { text: item.unit || 'ชิ้น', style: 'tableCell', alignment: 'center' },
                  { text: this.formatCurrency(item.unit_cost), style: 'tableCell', alignment: 'right' },
                  { text: this.formatCurrency(item.total_cost), style: 'tableCell', alignment: 'right' }
                ])
              ]
            },
            layout: 'lightHorizontalLines',
            margin: [0, 0, 0, 20]
          },
        ],
        // Summary
        // Signatures
        footer: function (currentPage, pageCount) {
          if (currentPage !== pageCount) return {}; // แสดงเฉพาะหน้าสุดท้าย

          return {
            margin: [40, -200, 40, 0], // <— ดึงขึ้น (negative top margin สำคัญ)
            lineHeight: 0.9,   // <— ค่านี้ยิ่งน้อย บรรทัดจะยิ่งชิดกัน
            stack: [
              // ==== 🎨 พื้นหลัง GRAND TOTAL เฉพาะแถวสุดท้าย ====
              {
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 0,
                    w: 225,   // ✅ ความกว้างพื้นหลัง
                    h: 25,    // ✅ ความสูงหนึ่งแถว
                    r: 5,    // ✅ ขอบมน 10px
                    color: '#E3F2FD'
                  }
                ],
                // ✅ ต้องปรับตำแหน่งให้เข้ากับเอกสารของคุณ
                // ค่านี้เบื้องต้น หากสูงเกิน/ต่ำไป แจ้งผมได้
                absolutePosition: { x: 330, y: -120 }
              },
              {
                columns: [
                  {
                    lineHeight: 0.9,   // <— ค่านี้ยิ่งน้อย บรรทัดจะยิ่งชิดกัน
                    width: '55%',
                    style: 'bathText',
                    stack: [
                      // เงื่อนไข
                      {
                        text: 'หมายเหตุ:',
                        style: 'subheader',
                        margin: [0, 10, 0, 0]
                      },
                      {
                        text: `${orderData.notes ? orderData.notes : 'รอเปิดบิล'}`,
                        margin: [20, 0, 0, 21], fontSize: 13

                      },
                      {
                        text: `(${numberToThaiText(orderData.total_amount)})`,
                        margin: [0, 25, 0, 0], fontSize: 16
                      }
                    ],
                    margin: [5, 0, 40, 0], // <— ดึงขึ้น (negative top margin สำคัญ)
                  },
                  {
                    width: '53%',
                    table: {
                      body: [
                        // สำหรับ VAT INCLUDE - ใช้โครงสร้างเดิมแต่เปลี่ยนข้อความอธิบาย
                        [
                          { text: 'รวมจำนวนเงิน (TOTAL AMOUNT):', alignment: 'right', fontSize: 14 },
                          { text: `${(formatCurrency(orderData?.subTotal) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 14 }
                        ],
                        [
                          { text: 'ส่วนลด (DISCOUNT):', alignment: 'right', fontSize: 14 },
                          { text: `${(formatCurrency(orderData?.discount_amount) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 14 }
                        ],
                        [
                          { text: 'ราคาสินค้าไม่รวมภาษี (SUB TOTAL):', alignment: 'right', fontSize: 14 },
                          { text: `${(formatCurrency(orderData.total_amount - orderData.tax_amount) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 14 }
                        ],
                        [
                          { text: `ภาษีมูลค่าเพิ่ม (VAT):`, alignment: 'right', fontSize: 14 },
                          { text: `${(formatCurrency(orderData?.tax_amount) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 14 }
                        ],
                        [
                          { text: 'รวมทั้งสิ้น (GRAND TOTAL):', bold: true, alignment: 'right', fontSize: 14 },
                          { text: `${formatCurrency(orderData?.total_amount).toLocaleString()} บาท`, bold: true, alignment: 'right', fontSize: 14 }
                        ],
                      ]
                    },
                    layout: 'noBorders'
                  }
                ],
                margin: [0, 0, 0, 20]
              },

              // ลายเซ็น
              {
                columns: [
                  {
                    width: '25%',
                    alignment: 'center',
                    text: [
                      '\n\n',
                      '(............................................)\n',
                      'ผู้สั่งซื้อ',
                    ],
                    fontSize: 16
                  },
                  {
                    width: '80%',
                    alignment: 'center',
                    stack: [
                      signatureImageNode || { text: '\n\n' },
                      {
                        text: [
                          '(............................................)\n',
                          'ผู้อนุมัติ',
                        ]
                      }
                    ],
                    fontSize: 16
                  }
                ]
              }
            ]
          };
        },
        styles: this.getStyles()
      };

      //return pdfMake.createPdf(docDefinition);

      const sectionTitle = `คำสั่งซื้อ ${orderData.purchase_number}`;
      //const fileName = `${sectionTitle}_${dayjs().format('YYYYMMDD_HHmm')}.pdf`;

      //pdfMake.createPdf(docDefinition).download(fileName);

      const pdfDocGenerator = window.pdfMake.createPdf(docDefinition);

      return new Promise((resolve, reject) => {
        pdfDocGenerator.getDataUrl((dataUrl) => {
          if (dataUrl) resolve(dataUrl);
          else reject(new Error('ไม่สามารถสร้าง PDF preview ได้'));
        });
      });


    } catch (error) {
      console.error('Error generating purchase order PDF:', error);
      throw error;
    }
  }

  // =============================================================================
  // GOODS RECEIPT PDF
  // =============================================================================

  async generateReceiptPDF(receiptData) {
    try {
      console.log('ใบรับสินค้าเข้าคลัง', receiptData);
      const companyInfo = await this.getCompanyInfo();
      let userInfo = { name: receiptData.received_by_name || receiptData.created_by_name || '-' };
      if (receiptData.created_by) {
        try {
          const res = await userService.getUserById(receiptData.created_by);
          userInfo = res?.data || userInfo;
        } catch (error) {
          console.warn('Cannot load goods receipt creator for PDF:', error.message);
        }
      }

      const normalizedReceipt = {
        ...receiptData,
        gr_number: receiptData.gr_number || receiptData.receipt_number || '-',
        po_number: receiptData.po_number || receiptData.purchase_number || '-',
        items: Array.isArray(receiptData.items) ? receiptData.items : []
      };


      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 60, 40, 60],
        defaultStyle: {
          font: 'THSarabunNew',
          fontSize: 14
        },

        content: [
          // Header
          {
            columns: [
              // Company Logo
              companyInfo.logo ? {
                image: companyInfo.logo,
                width: 80,
                height: 60
              } : { text: '', width: 80 },

              // Company Info
              {
                stack: [
                  { text: companyInfo.name, style: 'companyName' },
                  { text: companyInfo.address, style: 'companyInfo' },
                  { text: `โทร: ${companyInfo.phone}`, style: 'companyInfo' },
                  { text: `Email: ${companyInfo.email}`, style: 'companyInfo' },
                  { text: `เลขประจำตัวผู้เสียภาษี: ${companyInfo.taxId}`, style: 'companyInfo' }
                ],
                width: '*'
              },

              // Document Title
              {
                stack: [
                  { text: 'ใบรับสินค้าเข้าคลัง', style: 'documentTitle' },
                  { text: 'GOODS RECEIPT NOTE', style: 'documentTitleEn' }
                ],
                width: 'auto',
                alignment: 'right'
              }
            ],
            columnGap: 20,
            margin: [0, 0, 0, 20]
          },

          // Document Info
          {
            columns: [
              {
                stack: [
                  { text: `เลขที่ใบรับสินค้า: ${normalizedReceipt.gr_number}`, style: 'documentInfo' },
                  { text: `วันที่รับสินค้า: ${this.formatDate(normalizedReceipt.receipt_date)}`, style: 'documentInfo' },
                  { text: `อ้างอิงใบสั่งซื้อ: ${normalizedReceipt.po_number}`, style: 'documentInfo' },
                  { text: `เอกสารผู้ขาย: ${normalizedReceipt.supplier_document_number || '-'}`, style: 'documentInfo' },
                  { text: `คลังรับเข้า: ${normalizedReceipt.warehouse_name || '-'}`, style: 'documentInfo' },
                  { text: `สถานะ: ${this.getStatusText(normalizedReceipt.status)}`, style: 'documentInfo' }
                ],
                width: '*'
              },

              {
                stack: [
                  { text: 'ข้อมูลผู้ขาย', style: 'sectionHeader' },
                  { text: normalizedReceipt.supplier_name || normalizedReceipt.company_name || '-', style: 'supplierInfo' },
                  { text: normalizedReceipt.address || '', style: 'supplierInfo' },
                  { text: `โทร: ${normalizedReceipt.phone || '-'}`, style: 'supplierInfo' },
                  { text: `Email: ${normalizedReceipt.email || '-'}`, style: 'supplierInfo' },
                  { text: `เลขผู้เสียภาษี: ${normalizedReceipt.tax_id || '-'}`, style: 'supplierInfo' }
                ],
                width: '*'
              }
            ],
            columnGap: 20,
            margin: [0, 0, 0, 20]
          },

          // Items Table
          {
            table: {
              headerRows: 1,
              widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'],
              body: [
                [
                  { text: 'ลำดับ', style: 'tableHeader' },
                  { text: 'รายการสินค้า', style: 'tableHeader' },
                  { text: 'จำนวนสั่ง', style: 'tableHeader' },
                  { text: 'จำนวนรับ', style: 'tableHeader' },
                  { text: 'ราคาต่อหน่วย', style: 'tableHeader' },
                  { text: 'จำนวนเงิน', style: 'tableHeader' },
                ],
                ...normalizedReceipt.items.map((item, index) => [
                  { text: (index + 1).toString(), style: 'tableCell', alignment: 'center' },
                  { text: item.product_name, style: 'tableCell' },
                  { text: this.formatNumber(item.quantity_ordered || item.po_quantity || 0), style: 'tableCell', alignment: 'right' },
                  { text: this.formatNumber(item.received_quantity), style: 'tableCell', alignment: 'right' },
                  { text: this.formatCurrency(item.unit_cost), style: 'tableCell', alignment: 'right' },
                  { text: this.formatCurrency(item.total_cost), style: 'tableCell', alignment: 'right' },
                ])
              ]
            },
            layout: 'lightHorizontalLines',
            margin: [0, 0, 0, 20]
          },

          // Summary
          {
            columns: [
              { text: '', width: '*' },
              {
                table: {
                  widths: ['auto', 'auto'],
                  body: [
                    [{ text: 'มูลค่าสินค้าที่รับ:', style: 'totalLabel' }, { text: this.formatCurrency(normalizedReceipt.total_received_value), style: 'totalValue' }]
                  ]
                },
                layout: 'noBorders',
                width: 200
              }
            ],
            margin: [0, 0, 0, 30]
          },

          // Additional Info
          normalizedReceipt.items.some(item => item.batch_number || item.expiry_date || item.location) ? {
            stack: [
              { text: 'ข้อมูลเพิ่มเติม:', style: 'sectionHeader' },
              {
                table: {
                  headerRows: 1,
                  widths: ['*', 'auto', 'auto', 'auto'],
                  body: [
                    [
                      { text: 'สินค้า', style: 'tableHeader' },
                      { text: 'หมายเลข Batch', style: 'tableHeader' },
                      { text: 'วันหมดอายุ', style: 'tableHeader' },
                      { text: 'ตำแหน่งจัดเก็บ', style: 'tableHeader' }
                    ],
                    ...normalizedReceipt.items
                      .filter(item => item.batch_number || item.expiry_date || item.location)
                      .map(item => [
                        { text: item.description || item.product_name, style: 'tableCell' },
                        { text: item.batch_number || '-', style: 'tableCell' },
                        { text: item.expiry_date ? this.formatDate(item.expiry_date) : '-', style: 'tableCell' },
                        { text: item.location || '-', style: 'tableCell' }
                      ])
                  ]
                },
                layout: 'lightHorizontalLines'
              }
            ],
            margin: [0, 0, 0, 30]
          } : {},

          // Notes
          normalizedReceipt.notes ? {
            stack: [
              { text: 'หมายเหตุ:', style: 'sectionHeader' },
              { text: normalizedReceipt.notes, style: 'notes' }
            ],
            margin: [0, 0, 0, 30]
          } : {},

          // Signatures
          {
            columns: [
              {
                stack: [
                  { text: 'ผู้รับสินค้า', style: 'signatureLabel' },
                  { text: '\n\n', margin: [0, 20, 0, 0] },
                  { text: '................................', style: 'signatureLine' },
                  { text: `(${userInfo.name})`, style: 'signatureName' },
                  { text: `วันที่ ${this.formatDate(normalizedReceipt.receipt_date)}`, style: 'signatureDate' }
                ],
                width: '*',
                alignment: 'center'
              },

              normalizedReceipt.confirmed_by_name ? {
                stack: [
                  { text: 'ผู้ตรวจสอบ', style: 'signatureLabel' },
                  { text: '\n\n', margin: [0, 20, 0, 0] },
                  { text: '................................', style: 'signatureLine' },
                  { text: `(${normalizedReceipt.confirmed_by_name})`, style: 'signatureName' },
                  { text: `วันที่ ${this.formatDate(normalizedReceipt.confirmed_at)}`, style: 'signatureDate' }
                ],
                width: '*',
                alignment: 'center'
              } : {
                stack: [
                  { text: 'ผู้ตรวจสอบ', style: 'signatureLabel' },
                  { text: '\n\n', margin: [0, 20, 0, 0] },
                  { text: '................................', style: 'signatureLine' },
                  { text: '(                    )', style: 'signatureName' },
                  { text: 'วันที่ ....../....../......', style: 'signatureDate' }
                ],
                width: '*',
                alignment: 'center'
              }
            ],
            columnGap: 50
          }
        ],

        styles: this.getStyles()
      };

      // return pdfMake.createPdf(docDefinition);

      docDefinition.content = docDefinition.content.filter(node => node && Object.keys(node).length > 0);
      const pdfDocGenerator = window.pdfMake.createPdf(docDefinition);

      return new Promise((resolve, reject) => {
        pdfDocGenerator.getDataUrl((dataUrl) => {
          if (dataUrl) resolve(dataUrl);
          else reject(new Error('ไม่สามารถสร้าง PDF preview ได้'));
        });
      });



    } catch (error) {
      console.error('Error generating goods receipt PDF:', error);
      throw error;
    }
  }

  // =============================================================================
  // UTILITY METHODS
  // =============================================================================

  // Get PDF styles
  getStyles() {
    return {
      companyName: {
        fontSize: 18,
        bold: true,
        color: '#1890ff'
      },
      companyInfo: {
        fontSize: 12,
        color: '#000000'
      },
      documentTitle: {
        fontSize: 24,
        bold: true,
        color: '#1890ff'
      },
      documentTitleEn: {
        fontSize: 14,
        color: '#666666'
      },
      documentInfo: {
        fontSize: 14,
        margin: [0, 2, 0, 2]
      },
      sectionHeader: {
        fontSize: 16,
        bold: true,
        color: '#1890ff',
        margin: [0, 0, 0, 10]
      },
      supplierInfo: {
        fontSize: 12,
        margin: [0, 1, 0, 1]
      },
      tableHeader: {
        fontSize: 14,
        bold: true,
        fillColor: '#f0f0f0',
        margin: [5, 5, 5, 5],
        alignment: 'center'
      },
      tableCell: {
        fontSize: 12,
        margin: [5, 5, 5, 5]
      },
      summaryLabel: {
        fontSize: 14,
        alignment: 'right',
        margin: [0, 2, 10, 2]
      },
      summaryValue: {
        fontSize: 14,
        alignment: 'right',
        margin: [0, 2, 0, 2]
      },
      totalLabel: {
        fontSize: 16,
        bold: true,
        alignment: 'right',
        margin: [0, 5, 10, 5]
      },
      totalValue: {
        fontSize: 16,
        bold: true,
        alignment: 'right',
        margin: [0, 5, 0, 5],
        color: '#1890ff'
      },
      notes: {
        fontSize: 12,
        margin: [0, 5, 0, 5]
      },
      signatureLabel: {
        fontSize: 14,
        bold: true,
        margin: [0, 0, 0, 30]
      },
      signatureLine: {
        fontSize: 14,
        margin: [0, 5, 0, 5]
      },
      signatureName: {
        fontSize: 14,
        margin: [0, 5, 0, 2]
      },
      signatureDate: {
        fontSize: 12,
        color: '#666666'
      }
    };
  }

  // Format currency
  formatCurrency(amount) {
    return new Intl.NumberFormat('th-TH', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(parseFloat(amount || 0));
  }

  // Format number
  formatNumber(number) {
    return new Intl.NumberFormat('th-TH', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(parseFloat(number || 0));
  }

  // Format date
  formatDate(date) {
    if (!date) return '';
    return new Intl.DateTimeFormat('th-TH', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date(date));
  }

  // Get status text
  getStatusText(status) {
    const statusTexts = {
      'draft': 'ร่าง',
      'pending': 'รอดำเนินการ',
      'approved': 'อนุมัติแล้ว',
      'received': 'รับสินค้าแล้ว',
      'completed': 'เสร็จสิ้น',
      'cancelled': 'ยกเลิก',
      'confirmed': 'ยืนยันแล้ว',
      'posted': 'บันทึกแล้ว'
    };

    return statusTexts[status] || status;
  }

  // Get payment type text
  getPaymentTypeText(type) {
    const paymentTypes = {
      'cash': 'เงินสด',
      'credit': 'เงินเชื่อ'
    };

    return paymentTypes[type] || type;
  }

  // Print PDF
  printPDF(pdfDoc, filename = 'document.pdf') {
    try {
      pdfDoc.print();
    } catch (error) {
      console.error('Error printing PDF:', error);
      // Fallback to download
      this.downloadPDF(pdfDoc, filename);
    }
  }

  // Download PDF
  downloadPDF(pdfDoc, filename = 'document.pdf') {
    try {
      pdfDoc.download(filename);
    } catch (error) {
      console.error('Error downloading PDF:', error);
      throw error;
    }
  }

  // Open PDF in new window
  openPDF(pdfDoc) {
    try {
      pdfDoc.open();
    } catch (error) {
      console.error('Error opening PDF:', error);
      throw error;
    }
  }
}

// Export singleton instance
export default new PurchasePrintService();
